// For reusable functions

document.addEventListener("turbolinks:load", () => {
  autoLink();
  characterCounter();

  function autoLink() {
    const urlRegex = /((https?:\/\/|www\.)[^\s<]+)/gi;

    document.querySelectorAll('.autolink').forEach(element => {
      element.innerHTML = element.textContent.replace(urlRegex, match => {
        const trailing = match.match(/[.,!?;:)\]}]+$/);
        const punctuation = trailing ? trailing[0] : '';
        const url = punctuation ? match.slice(0, -punctuation.length) : match;
        const href = url.startsWith('www.') ? `https://${url}` : url;

        return `<a href="${href}" target="_blank" rel="noopener noreferrer" style="color: var(--os-colorIconAccent);">${url}</a>${punctuation}`;
      });
    });
  }

  function characterCounter() {
    document.querySelectorAll('textarea[maxlength]').forEach(field => {
      const counter = field.parentElement.querySelector('.char-counter');

      if (!counter) return;
      
      const updateCounter = () => {
        counter.textContent = `Character count: ${field.value.length} / ${field.maxLength}`;
      };

      field.addEventListener('input', updateCounter);
      updateCounter();
      });
  }

});
